var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSdKsAndLibrariesSvg = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_12111_27036)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.91146 12.25V11.0833C9.75675 11.0833 9.60838 11.0219 9.49898 10.9125C9.38958 10.8031 9.32812 10.6547 9.32812 10.5V9.91667C9.32812 9.60725 9.45104 9.3105 9.66983 9.09171C9.88863 8.87292 10.1854 8.75 10.4948 8.75H11.6615C11.9709 8.75 12.2676 8.87292 12.4864 9.09171C12.7052 9.3105 12.8281 9.60725 12.8281 9.91667V10.5C12.8281 10.6547 12.7667 10.8031 12.6573 10.9125C12.5479 11.0219 12.3995 11.0833 12.2448 11.0833",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_12111_27036)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.0885 8.75V3.79167C11.0885 3.25018 10.8734 2.73088 10.4906 2.34799C10.1077 1.9651 9.58836 1.75 9.04688 1.75C8.50539 1.75 7.98609 1.9651 7.6032 2.34799C7.22031 2.73088 7.00521 3.25018 7.00521 3.79167V10.2083C7.00521 10.7498 6.7901 11.2691 6.40722 11.652C6.02433 12.0349 5.50503 12.25 4.96354 12.25C4.42206 12.25 3.90275 12.0349 3.51987 11.652C3.13698 11.2691 2.92188 10.7498 2.92188 10.2083V5.25",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_i_12111_27036)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.2552 12.2507V11.084H9.92188",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_i_12111_27036)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.75 2.91667H4.08333V1.75",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_i_12111_27036)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.08854 2.91667C4.24325 2.91667 4.39162 2.97812 4.50102 3.08752C4.61042 3.19692 4.67187 3.34529 4.67187 3.5V4.08333C4.67187 4.39275 4.54896 4.6895 4.33017 4.90829C4.11137 5.12708 3.81463 5.25 3.50521 5.25H2.33854C2.02912 5.25 1.73238 5.12708 1.51358 4.90829C1.29479 4.6895 1.17188 4.39275 1.17188 4.08333V3.5C1.17188 3.34529 1.23333 3.19692 1.34273 3.08752C1.45213 2.97812 1.6005 2.91667 1.75521 2.91667V1.75",
  stroke: "#F35B22",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_12111_27036",
  x: 8.82812,
  y: 8.25,
  width: 5.5,
  height: 5.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12111_27036"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_12111_27036",
  x: 2.42188,
  y: 1.25,
  width: 10.1641,
  height: 12.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12111_27036"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_i_12111_27036",
  x: 9.42188,
  y: 10.584,
  width: 4.33594,
  height: 3.16699,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12111_27036"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_i_12111_27036",
  x: 1.25,
  y: 1.25,
  width: 4.33594,
  height: 3.16699,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12111_27036"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_i_12111_27036",
  x: 0.671875,
  y: 1.25,
  width: 5.5,
  height: 5.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.466667 0 0 0 0 0.211765 0 0 0 0 0.109804 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_12111_27036"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSdKsAndLibrariesSvg);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";